import { GetterTree } from 'vuex'
import { RealworksStatusRuleState } from '@/store/realworksStatusRules/index'
import { RootState } from '@/store'

export const getters: GetterTree<RealworksStatusRuleState, RootState> = {
    requestParams(state: RealworksStatusRuleState): any {
        const params = {
            pagination: true,
            page: state.page,
            itemsPerPage: state.itemsPerPage,
            company: state.companyFilter,
        }

        if (state.orderField && state.orderDirection) {
            params[`order[${state.orderField}]`] = state.orderDirection
        }

        return params
    },
}
